<div class="autocomplete">
  <div
    class="autocomplete__input-group"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    #inputGroup
  >
    <div class="autocomplete__input-wrapper">
      <i class="fas fa-search autocomplete__search-icon"></i>
      <input
        type="text"
        [placeholder]="settings?.placeholder"
        [disabled]="settings?.disabled"
        autocomplete="off"
        class="form-control"
        [ngModel]="selectedItem?.label || searchText"
        (ngModelChange)="onModelChange($event)"
      />
      <button
        type="button"
        class="autocomplete__clear-button"
        *ngIf="selectedItem?.id"
        (click)="clearSelection()"
      >
        <i class="fas fa-times"> </i>
      </button>
    </div>

    <div *ngIf="settings?.showAfterContent">
      <ng-content select="[after]"></ng-content>
    </div>
  </div>

  <ng-content select="[info]"></ng-content>

  <ng-container *ngIf="shouldShowNoResults()">
    <p class="autocomplete__no-results">
      {{ settings?.noResultsText }}
    </p>
  </ng-container>
</div>

<ng-template #itemsTpl>
  <ng-content select="[item]"></ng-content>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="!!settings?.isOpenDropdown"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="overlayPanelClass"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
  (detach)="onOverlayDetach()"
>
  <ul class="autocomplete__dropdown autocomplete__dropdown--show" #dropdown>
    <ng-container [ngTemplateOutlet]="itemsTpl"></ng-container>
  </ul>
</ng-template>
